import { Expose } from 'class-transformer'

export class GetMonthQuotesDTO {

    @Expose()
    monthQuotes!: any[]

}
